import { useContext } from "react";
import NationalExecutiveCommittee from "../NationalExecutiveCommittee";
import PoliticalDocuments from "../PoliticalDocuments";
import { PoliticalPartyDBContext } from "../PoliticalPartyDBContext";
import PoliticalPartyExecutiveTermDropdown from "../PoliticalPartyExecutiveTermDropdown";
import PoliticalPartyInfo from "../PoliticalPartyInfo";



export default function () {
    var { partyExecutiveTermID } = useContext(PoliticalPartyDBContext);

  return (<>
    <div className="card">
      <PoliticalPartyExecutiveTermDropdown />
      {!["", null, undefined].includes(partyExecutiveTermID) && (<><NationalExecutiveCommittee header={"Executive Committee"} hideButtons={true} key={partyExecutiveTermID} /></>)}
    </div>
  </>)
}